export { Hero } from './Hero';
